import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SmContextMenuItemModel} from '../sm-context-menu-item/sm-context-menu-item.component';
import {GlobalSearchContainerResult} from '../../search/global-search.service';
import {formatContainerSearchResultParentPath} from '../../search/search-result-path';
import {SmContainerListItemModel} from '../sm-container-list-item/sm-container-list-item.component';
import type {InventoryMenuOptions} from '../sm-inventory-context-menu/sm-inventory-context-menu.component';

@Component({
  selector: 'sm-global-search-container-result',
  templateUrl: './sm-global-search-container-result.component.html',
  styleUrls: ['./sm-global-search-container-result.component.scss'],
  standalone: false,
})
export class SmGlobalSearchContainerResultComponent {
  @Input({required: true}) result!: GlobalSearchContainerResult;
  @Input() menuItems: SmContextMenuItemModel[] = [];
  @Input() inventoryMenu: InventoryMenuOptions | null = null;
  @Input() menuAriaLabelTemplate = '';
  @Input() emptyDescriptionLabel = '';
  @Input() searchQuery = '';
  @Input() openLabelTemplate = '';
  @Input() rootLocationLabel = '';
  @Input() currentLabel = '';

  @Output() open = new EventEmitter<GlobalSearchContainerResult>();
  @Output() menuItemSelect = new EventEmitter<SmContextMenuItemModel>();

  get container(): SmContainerListItemModel {
    return {
      id: this.result.id,
      name: this.result.name,
      description: this.result.description,
      imageUrl: this.result.imageUrl,
      isFavorite: this.result.isFavorite,
      selected: this.result.isCurrent,
      contextPathText: this.locationText,
      contextIconName: 'location-outline',
      contextAriaLabel: this.formatTemplate(this.openLabelTemplate, {
        name: this.result.name,
        containerName: this.locationText,
      }) || this.locationText,
      contextMetaText: this.result.isCurrent ? this.currentLabel : null,
    };
  }

  get locationText(): string {
    return formatContainerSearchResultParentPath(
      this.result.path,
      this.rootLocationLabel.trim() || 'Root',
    );
  }

  get menuAriaLabel(): string {
    return this.formatTemplate(this.menuAriaLabelTemplate, {name: this.result.name}) || this.result.name;
  }

  handleOpen(): void {
    this.open.emit(this.result);
  }

  handleMenuItemSelect(item: SmContextMenuItemModel): void {
    this.menuItemSelect.emit(item);
  }

  formatTemplate(template: string, values: Record<string, string>): string {
    if (!template.trim()) {
      return '';
    }

    return Object.entries(values).reduce(
      (current, [key, value]) => current.split(`{{${key}}}`).join(value),
      template,
    );
  }
}
